import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Blog } from '../core/models/blog.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlogService {
  private apiUrl = `${environment.apiUrl}/blogs`;
  // Base URL for images - resimler /uploads/blogs/ altında, API'nin kök dizininde
  private readonly imageBaseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  /**
   * Tüm blogları getirir (yayınlanmış ve taslak)
   */
  getAllBlogs(): Observable<Blog[]> {
    return this.http.get<Blog[]>(this.apiUrl);
  }

  /**
   * Sadece yayınlanmış blogları getirir
   * Public kullanım için tercih edilmelidir
   */
  getPublishedBlogs(): Observable<Blog[]> {
    return this.http.get<Blog[]>(`${this.apiUrl}/published`);
  }

  /**
   * ID'ye göre blog detayını getirir
   * @param id Blog ID'si
   */
  getBlogById(id: string): Observable<Blog> {
    return this.http.get<Blog>(`${this.apiUrl}/${id}`);
  }

  /**
   * Slug değerine göre blog detayını getirir
   * SEO için önerilen yöntem
   * @param slug Blog'un URL dostu benzersiz ismi
   */
  getBlogBySlug(slug: string): Observable<Blog> {
    return this.http.get<Blog>(`${this.apiUrl}/slug/${slug}`);
  }

  /**
   * Kategoriye göre blogları getirir
   * @param categoryId Kategori ID'si
   */
  getBlogsByCategory(categoryId: string): Observable<Blog[]> {
    return this.http.get<Blog[]>(`${this.apiUrl}/category/${categoryId}`);
  }

  /**
   * Blog görsel URL'sini tam URL'ye çevirir
   * @param imagePath Görselin path'i (örn: /uploads/blogs/abc123.jpg)
   */
  getImageUrl(imagePath: string | undefined): string | null {
    if (!imagePath) {
      return null;
    }
    
    // Eğer tam URL ise direkt dön
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    // Relative path ise base URL ile birleştir
    return `${this.imageBaseUrl}${imagePath}`;
  }
}


